import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { List } from '@styled-icons/evaicons-solid/List';
import { MessageSquareAdd } from '@styled-icons/boxicons-regular/MessageSquareAdd';

//Actions
import { item as pesquisaitem } from '../../../../actions/produto/item';
import { subitem as pesquisasubitem, subitemselecionado, zerapesquisa } from '../../../../actions/produto/subitem';

//Compoments
import DashboardMenu from '../../components/dashboard/DashboardMenu';
import Header from '../../components/layouts/header';
import FormProdutos from '../../components/forms/FormProdutos'
import Body from '../../components/layouts/body';
import ListaCadastro from '../../components/forms/ListaCadastro';


//Helpers
import { TelaModalLivre } from '../../../../helpers/TelaModal';

//Utils
import { getEvento } from '../../../../utils/eventosession';

class Produtos extends React.Component {

    state = {
        pesquisamodal: false,
        formCad: false
    }
    
    async componentDidMount(){
        const evento = getEvento();
        const item = await this.props.pesquisaitem({idevento: evento.idevento, idpromotora: evento.idpromotora});
        const dados = {            
            iditems: ((item&&item[0])?item[0].iditems:0),
            idpromotora: evento.idpromotora,
            idevento: evento.idevento
        }
        await this.props.pesquisasubitem(dados);
    }
    
    handleSubmit = (form) => {
        const evento = getEvento();
        const dados = {
            ...form,
            iditems: this.props.itemevento[0]?this.props.itemevento[0].iditems:0,
            idpromotora: evento.idpromotora,
            idevento: evento.idevento
        }
        this.props.pesquisasubitem(dados);        
    }

    handleCloseModal = () => {
        this.setState({
            pesquisamodal: !this.state.pesquisamodal?true:false
        })
    }

    handleFormCad = () => {
        this.setState({
            formCad: !this.state.formCad?true:false
        })
    }

    handleEditFormCad = () => {
        this.setState({
            formCad: true
        })
    }
    
    render() {
        return (
            <>
            <TelaModalLivre show={this.state.pesquisamodal} handleCloseModal={this.handleCloseModal} titulo="Pesquisa Produtos Cadastrados">
                <ListaCadastro 
                {...this.props} 
                cadastroselecionado={this.props.subitemselecionado} 
                pesquisa={this.props.pesquisasubitem} 
                handleSubmit={this.handleSubmit}
                handleCloseModal={this.handleCloseModal}
                handleZeraPesquisa={this.props.zerapesquisa}
                handleEditFormCad={this.handleEditFormCad}
                {...{
                    col0campo: 'portugues',
                    col1campo: 'descricao_portugues',
                    col2campo: 'codigo',                    
                    col0desc: 'Nome',
                    col1desc: 'Descrição',
                    col2desc: 'Ordem',
                    campopesquisa: 'portugues',
                    placeholder: 'Ex. curso de tintas...'
                }}
                />
            </TelaModalLivre> 
            <DashboardMenu />
            <Header titulo="Cadastro de Produtos" subtitulo="Cadastro" descricao="" />
            <Body>
                <Button variant="outline-info" className="mb-4" size="lg" block onClick={this.handleCloseModal}>
                    <List size="30" />
                    Produtos Cadastrados
                </Button>
                {this.state.formCad?
                <FormProdutos  />
                :
                <Button variant="primary" className="mb-4" size="lg" block onClick={this.handleFormCad}>
                    <MessageSquareAdd size="30" />
                    Novo
                </Button>
                }                
            </Body>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        itemevento: state.reducerPesquisaItem,
        cadastros: state.reducerPesquisaSubitem        
    }
}

export default connect(mapStateToProps,{pesquisaitem,pesquisasubitem,subitemselecionado, zerapesquisa})(withRouter(Produtos));